import React from "react";
import Form from "../common/Form";
import { getBackgroundClass } from "../../utils/sectionHelpers";
import { renderText } from "../common/renderText";
import { Link } from "react-router-dom";
import { HighlightText } from "../common/HighlightText";

const UiUxForm = ({ data }) => {
  const settings = data?.Settings || {};

  const backgroundClass = getBackgroundClass(settings.background);
  return (
    <>
      <div
        className={`seo-analysis-section ptb-70 ${backgroundClass} form-sec`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-lg-6 text-start"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div className="analysis-form mt-0">
                <h2><HighlightText content={data.title} /></h2>
                {data?.description?.map((block, index) => {
                  switch (block.type) {
                    case "paragraph":
                      return <p key={index}>{renderText(block.children)}</p>;

                    case "heading":
                      const Tag = `h${block.level}`;
                      return (
                        <Tag key={index} className="mt-4 mb-3">
                          <HighlightText content={block.children.map((c) => c.text).join("")} />
                        </Tag>
                      );

                    case "list":
                      const ListTag = block.format === "ordered" ? "ol" : "ul";
                      return (
                        <div className="overview-box">
                          <div className="overview-content">
                            <div className="content">
                              <ListTag key={index} className="list-unstyled">
                                {block.children.map((item, i) => (
                                  <li key={i} className="features-text">
                                    <h4>
                                      <i className="flaticon-tick"></i>
                                      <span>
                                        {item.children.map((child, j) => {
                                          const isBold =
                                            child.bold ||
                                            child.marks?.some(
                                              (mark) => mark.type === "bold",
                                            );

                                          if (isBold) {
                                            return <b key={j}>{child.text}</b>;
                                          }

                                          return child.text;
                                        })}
                                      </span>
                                    </h4>
                                  </li>
                                ))}
                              </ListTag>
                            </div>
                          </div>
                        </div>
                      );

                    default:
                      return null;
                  }
                })}
                {data.secButton ? (
                  <Link
                    to={data.secButton?.url}
                    target="_blank"
                    rel="noreferrer"
                    className="default-btn"
                  >
                    <i className="bx bx-support"></i>
                    {data.secButton?.label}
                    <span className="default-btn-hover"></span>
                  </Link>
                ) : null}
                {data.quotes ? (
                  <div className="partner-quote">
                    {data?.quotes?.map((block, index) => {
                      switch (block.type) {
                        case "paragraph":
                          return (
                            <p key={index} className="mb-0">
                              {renderText(block.children)}
                            </p>
                          );

                        case "heading":
                          const Tag = `h${block.level}`;
                          return (
                            <Tag key={index}>
                              <HighlightText content={block.children.map((c) => c.text).join("")} />
                            </Tag>
                          );

                        case "list":
                          const ListTag =
                            block.format === "ordered" ? "ol" : "ul";
                          return (
                            <div className="overview-box">
                              <div className="overview-content">
                                <div className="content">
                                  <ListTag
                                    key={index}
                                    className="list-unstyled"
                                  >
                                    {block.children.map((item, i) => (
                                      <li key={i} className="features-text">
                                        <h4>
                                          <i className="flaticon-tick"></i>
                                          <span>
                                            {item.children.map((child, j) => {
                                              const isBold =
                                                child.bold ||
                                                child.marks?.some(
                                                  (mark) =>
                                                    mark.type === "bold",
                                                );

                                              if (isBold) {
                                                return (
                                                  <b key={j}>{child.text}</b>
                                                );
                                              }

                                              return child.text;
                                            })}
                                          </span>
                                        </h4>
                                      </li>
                                    ))}
                                  </ListTag>
                                </div>
                              </div>
                            </div>
                          );

                        default:
                          return null;
                      }
                    })}
                  </div>
                ) : null}
              </div>
            </div>
            <div
              className="col-lg-6"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              <div className="contact-form">
                {data?.formTitle && (
                  <h3 className="text-start mb-4"><HighlightText content={data?.formTitle} /></h3>
                )}
                <Form section="top" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UiUxForm;
